import React from 'react';
import { ChevronDown } from 'lucide-react';
import { restaurantInfo, heroImages } from '../data/mock';

const Hero = () => {
  const scrollToMenu = () => {
    const element = document.querySelector('#menu');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImages.background}
          alt="Mangal ateşi"
          className="w-full h-full object-cover"
        />
        {/* Overlay Gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-stone-950/70 via-stone-950/50 to-stone-950/90" />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-950/60 via-transparent to-stone-950/60" />
      </div>

      {/* Animated Ember Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="ember-particle absolute w-1 h-1 bg-amber-500 rounded-full opacity-80"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-900/40 border border-amber-700/40 rounded-full mb-8 backdrop-blur-sm">
            <span className="w-2 h-2 bg-amber-500 rounded-full animate-pulse" />
            <span className="text-amber-200 text-sm tracking-wider">
              {restaurantInfo.since}'den beri Balıkesir'de
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold text-amber-50 mb-6 leading-tight">
            <span className="block">Ateşin Ruhu,</span>
            <span className="block text-amber-500">Köftenin Ustası</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-amber-100/80 mb-4 font-light">
            {restaurantInfo.tagline}
          </p>

          {/* Description */}
          <p className="text-amber-200/60 max-w-2xl mx-auto mb-12 text-lg leading-relaxed">
            {restaurantInfo.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToMenu}
              className="group px-8 py-4 bg-amber-600 hover:bg-amber-500 text-stone-950 font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-amber-600/30"
            >
              <span className="flex items-center justify-center gap-2">
                Menümüzü Keşfedin
                <ChevronDown className="w-5 h-5 group-hover:translate-y-1 transition-transform" />
              </span>
            </button>
            <a
              href="#locations"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#locations')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 border-2 border-amber-600/50 text-amber-100 hover:bg-amber-600/20 hover:border-amber-500 font-semibold rounded-lg transition-all duration-300"
            >
              Bize Ulaşın
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div
          onClick={scrollToMenu}
          className="cursor-pointer flex flex-col items-center gap-2 text-amber-400/60 hover:text-amber-400 transition-colors"
        >
          <span className="text-xs tracking-wider uppercase">Aşağı Kaydır</span>
          <ChevronDown className="w-6 h-6 animate-bounce" />
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-stone-950 to-transparent" />
    </section>
  );
};

export default Hero;